import { Fragment } from "react";
import { motion } from "framer-motion";
import { EASE } from "@/lib/lenis";

export const Reveal = ({ as = "div", delay = 0, y = 28, className, children, ...rest }) => {
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </Comp>
  );
};

const lineVariants = (delay) => ({
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 1.1, ease: EASE, delay } },
});

export const MaskedLines = ({ as = "h2", lines, className, lineClassName = "", onView = false, delay = 0, testId }) => {
  const Comp = motion[as];
  const trigger = onView
    ? { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { initial: "hidden", animate: "show" };
  return (
    <Comp className={className} data-testid={testId} {...trigger}>
      {lines.map((line, i) => (
        <Fragment key={`${line}-${i}`}>
          <span className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
            <motion.span className={`block ${lineClassName}`} variants={lineVariants(delay + i * 0.1)}>
              {line}
            </motion.span>
          </span>{" "}
        </Fragment>
      ))}
    </Comp>
  );
};
